import { ANALYTICS_EVENTS } from '../events'
import createAnalyticsStatic, { EventProps } from './createAnalyticsEvent'

export type OnboardingKycDocumentSubmittedProps = EventProps

/**
 * @event onboarding_kyc_document_submitted
 * @description Emitted when the user completes the FrankieOne KYC document upload screen and advances to review.
 */
export const OnboardingKycDocumentSubmittedAnalytics = createAnalyticsStatic<OnboardingKycDocumentSubmittedProps>(
    ANALYTICS_EVENTS.ONBOARDING.ONBOARDING_KYC_DOCUMENT_SUBMITTED,
)

export default OnboardingKycDocumentSubmittedAnalytics
